import { render } from "./BaseProgress.vue?vue&type=template&id=fb011b86"
import script from "./BaseProgress.vue?vue&type=script&lang=js"
export * from "./BaseProgress.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tito\\Documents\\Proyectos\\Dada\\dashboard-agente\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__